import { palette } from '@client/theme/colors';
import type { ThemeOptions } from '@mui/material';

const extraVariants: any = {
  colorInherit: {
    backgroundColor: palette.grey[300],

    '&::before': {
      backgroundColor: 'transparent',
    },
  },
  barColorInherit: {
    backgroundColor: palette.grey[500],
  },
};

declare module '@mui/material/CircularProgress' {
  interface CircularProgressPropsColorOverrides {
    grey: true;
    secondary_dark: true;
    textPrimary: true;
    textSecondary: true;
  }
}

const Progress: ThemeOptions['components'] = {
  MuiLinearProgress: {
    styleOverrides: {
      colorPrimary: {
        backgroundColor: palette.grey[300],
      },
      barColorPrimary: {
        backgroundColor: palette.success.main,
      },
      ...extraVariants,
    },
  },
  MuiMobileStepper: {
    styleOverrides: {
      root: {
        backgroundColor: 'transparent',
      },
      dotActive: {
        backgroundColor: palette.success.main,
      },
    },
  },
};

export default Progress;
